import T from '@wojtekmaj/react-t';

import CheckboxField from '@rewardopl/react-ui/checkbox_field';

import { Indent } from '../pages/login/email/form.styles';

type MarketingControlsProps = {
  marketingAccepted: boolean;
  marketingEmailAccepted: boolean;
  marketingSmsAccepted: boolean;
  setMarketingEmailAccepted: React.Dispatch<React.SetStateAction<boolean>>;
  setMarketingSmsAccepted: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function MarketingControls({
  marketingAccepted,
  marketingEmailAccepted,
  marketingSmsAccepted,
  setMarketingEmailAccepted,
  setMarketingSmsAccepted,
}: MarketingControlsProps) {
  return (
    <>
      <CheckboxField
        checked={marketingAccepted}
        name="marketing_accepted"
        label={
          <T>
            I consent to Salad Story S.A. providing information about the latest promotions,
            products and services of its own and about the promotions, products and services of its
            partners via e-mail or push messages.
          </T>
        }
        onChange={() => {
          setMarketingEmailAccepted(!marketingAccepted);
          setMarketingSmsAccepted(!marketingAccepted);
        }}
      />
      <Indent>
        <CheckboxField
          checked={marketingSmsAccepted}
          label={<T>SMS</T>}
          name="marketing_sms_accepted"
          onChange={() => {
            setMarketingSmsAccepted(!marketingSmsAccepted);
          }}
        />
        <CheckboxField
          checked={marketingEmailAccepted}
          name="marketing_email_accepted"
          label={<T>E-mail</T>}
          onChange={() => {
            setMarketingEmailAccepted(!marketingEmailAccepted);
          }}
        />
      </Indent>
    </>
  );
}
